<template>
        <div id="openAddButton">
            <i id="addButton" class="material-icons" @click="add">add</i>
        </div>
</template>

<script>
export default {
    data () {
        return {
        }
    },
    methods: {
        add () {
            this.$router.push({ name: 'addstao' });
        }
    }
}
</script>

<style scoped sass>

#openAddButton{
    position: absolute;
    top: 10px;
    right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50px;
    height:50px;
    border-radius: 50%;
    background-color: white;
    box-shadow: 0px 0px 10px grey;

}

#addButton{
    font-size: 40px;
    cursor: pointer;
}

#openAddButton:active{
    background-color: grey;
}

@media screen and (min-width: 500px){

}

@media screen and (min-width: 1300px){

}

</style>
